import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Col,
  Container,
  Image,
  ListGroup,
  Row,
  Nav,
  Dropdown,
  Card,
  Offcanvas,
} from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import { Icon } from "@iconify/react";
import IMAGES from "constants/images";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import ProfileDetailsForm from "./ProfileDetails";
import MyReviews from "./MyReviews";
import MyFavouritesTab from "./MyFavourites";
import NotificationsTab from "./Notifications";
import FollowFollowing from "./FollowFollowing";
import ChangePasswordModal from "./ChangePasswordModal"; // ⬅️ Add import
import CreateListModal from "./CreateListModal";
import { useAuth } from "context/UserContext";
import { useFetchProfile } from "hooks/useFetchProfile";
import { useSearchParams } from "react-router-dom";

const MyProfile = () => {
  const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState(0);
  const [show, setShow] = useState(false);
  const location = useLocation();
  // const  followTabState = location.state?.followTab || "Followers";
  const [refreshFavList, setRefreshFavList] = useState(false);
  const { showFollowers, setShowFollowers, followTab, setFollowTab } =
    useAuth();

  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = Number(searchParams.get("tab")) || 0;
  const [activeTab, setActiveTab] = useState(defaultTab);

  console.log("followTab", followTab, showFollowers, activeTab);
  // Followers List
  const [followers, setFollowers] = useState([
    {
      id: 1,
      name: "Amelia Zajac",
      followers: "1.2k",
      image: IMAGES.User1_IMG,
    },
    {
      id: 2,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 3,
      name: "Emmanuel Pérez",
      followers: "1.2k",
      image: IMAGES.User3_Img,
    },
    {
      id: 4,
      name: "Amelia Zajac",
      followers: "1.2k",
      image: IMAGES.User1_IMG,
    },
    {
      id: 5,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 6,
      name: "Emmanuel Pérez",
      followers: "1.2k",
      image: IMAGES.User3_Img,
    },
    {
      id: 7,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
  ]);

  // Following List
  const [following, setFollowing] = useState([
    {
      id: 1,
      name: "Sara Adébáyọ̀",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 2,
      name: "Slack",
      followers: "1.2k",
      image: IMAGES.Follow1_IMG,
    },
    {
      id: 3,
      name: "Hugo Silva",
      followers: "1.2k",
      image: IMAGES.Follow2_IMG,
    },
    {
      id: 4,
      name: "Sara Adébáyọ̀",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 5,
      name: "Slack",
      followers: "1.2k",
      image: IMAGES.Follow1_IMG,
    },
    {
      id: 6,
      name: "Hugo Silva",
      followers: "1.2k",
      image: IMAGES.Follow2_IMG,
    },
  ]);

  const handleRemove = (id) => {
    setFollowers(followers.filter((user) => user.id !== id));
    setFollowing(following.filter((user) => user.id !== id));
  };

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  //
  const [showModal1, setShowModal1] = useState(false);

  const handleCloseModal1 = () => {
    setShowModal1(false);
  };

  //
  const [showModal2, setShowModal2] = useState(false);

  const handleCloseModal2 = () => {
    setShowModal2(false);
  };

  const handleShowFollowers = () => {
    setShowFollowers(!showFollowers);
  };

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  console.log("first", activeTab, showFollowers);

  // List Menu
  const menuItems = [
    { id: 0, name: "Profile Details", icon: "ep:user" },
    {
      id: 1,
      name: "My Reviews",
      icon: "material-symbols-light:reviews-outline",
    },
    { id: 2, name: "My Favorites", icon: "solar:heart-linear" },
    { id: 3, name: "Notifications", icon: "mi:notification" },
    { id: 4, name: "Logout", icon: "humbleicons:logout" },
  ];

  const handleItemClick = (id) => {
    if (id === 4) {
      setShowModal2(true); // Open logout modal
    } else {
      setShowFollowers(false); // Hide Follow/Following tab
      setActiveTab(id); // Switch tab
      setSearchParams({ tab: id });
    }
  };

  const { logout, user, refetchProfile } = useAuth();

  const handleLogout = () => {
    logout();
    // navigate("/");
  };

  const currenttab = menuItems.find((v) => v.id === activeTab);
  console.log("showFollowers", showFollowers);
  return (
    <React.Fragment>
      {/* BreadCrumb Section */}
      <BreadcrumbSection
        setShowFollowers={setShowFollowers}
        breadcrumbs={[
          activeTab === 0
            ? { title: "My Profile", link: showFollowers && "/my-profile" }
            : { title: "My Profile", link: "/my-profile?tab=0" },

          ...(activeTab > 0 && currenttab?.name
            ? [{ title: currenttab.name }]
            : []),
        ]}
      />

      {/* <BreadcrumbSection
        breadcrumbs={[
          {
            title: "Solutions",

            link: "/solutions",
          },
          { title: "Client-Side Protection" }, // Active breadcrumb (no link)
        ]}
      /> */}

      <section className="software_section ">
        <Container>
          <Row>
            {/* <div className="showSideMobil">
              <div onClick={() => setShow(true)}>
                Menu{" "}
                <Icon
                  icon="material-symbols-light:menu-rounded"
                  className="ms-2"
                  color="#ffffff"
                  fontSize={25}
                />
              </div>
            </div> */}
            {/* Sidebar */}
            <Col className="hide1199" style={{ maxWidth: "296px",height: "max-content"  }}>
              <div className="profile-sidebar">
                <div className="profile-sidebar-image">
                  <Link
                    to="/my-profile"
                    onClick={() => setShowFollowers(false)}
                  >
                    <Image
                      style={{ width: 80, height: 80 }}
                      src={user?.profileUrl || IMAGES.User2_Img}
                      roundedCircle
                    />
                  </Link>

                  <div
                    onClick={() => {
                      setFollowTab("Followers");
                      setShowFollowers(true);
                    }}
                    className="cursor-pointer"
                  >
                    <h3>{user?.followersCount || "0"}</h3>
                    <p>Followers</p>
                  </div>
                  <div
                    onClick={() => {
                      setFollowTab("Following");
                      setShowFollowers(true);
                    }}
                    className="cursor-pointer"
                  >
                    <h3>{user?.followingCount || "0"}</h3>
                    <p>Following</p>
                  </div>
                </div>
                <h5>
                  {user?.firstName} {user?.lastName}
                </h5>
                <p className="text-muted">{user?.email}</p>
                <div className="divider"></div>
                <ListGroup variant="flush">
                  {menuItems.map((item) => (
                    <ListGroup.Item
                      key={item.id}
                      className={activeTab === item.id ? "active" : ""}
                      onClick={() => handleItemClick(item.id)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <Icon icon={item.icon} color="#000000" fontSize={20} />
                      <span style={{ marginLeft: 10 }}>{item.name}</span>
                      <div className="ms-auto">
                        <Icon
                          icon="mynaui:chevron-right"
                          color="#6E6E73"
                          fontSize={25}
                        />
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            </Col>
            <Offcanvas show={show} onHide={() => setShow(false)}>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Profile Menu</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="showSideMobilContent">
                <div className="profile-sidebar">
                  <div className="profile-sidebar-image">
                    <Image
                      style={{ width: 80, height: 80 }}
                      src={user?.profileUrl || IMAGES.User2_Img}
                      roundedCircle
                    />

                    <div
                      onClick={() => {
                        setFollowTab("Followers");
                        setShowFollowers(true);
                        setShow(false);
                      }}
                      className="cursor-pointer"
                    >
                      <h3>{user?.followersCount || "0"}</h3>
                      <p>Followers</p>
                    </div>
                    <div
                      onClick={() => {
                        setFollowTab("Following");
                        setShowFollowers(true);
                        setShow(false);
                      }}
                      className="cursor-pointer"
                    >
                      <h3>{user?.followingCount || "0"}</h3>
                      <p>Following</p>
                    </div>
                  </div>
                  <h5>
                    {user?.firstName} {user?.lastName}
                  </h5>
                  <p className="text-muted">{user?.email}</p>
                  <div className="divider"></div>
                  <ListGroup variant="flush">
                    {menuItems.map((item) => (
                      <ListGroup.Item
                        key={item.id}
                        className={activeTab === item.id ? "active" : ""}
                        onClick={() => {
                          handleItemClick(item.id);
                          setShow(false);
                        }}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon icon={item.icon} color="#000000" fontSize={20} />
                        <span style={{ marginLeft: 10 }}>{item.name}</span>
                        <div className="ms-auto">
                          <Icon
                            icon="mynaui:chevron-right"
                            color="#6E6E73"
                            fontSize={25}
                          />
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
            <Col style={{ width: "100%" }}>
              <div className="right_profile_style">
                {showFollowers ? (
                  <FollowFollowing
                    followers={followers}
                    following={following}
                    onRemove={handleRemove}
                    followTab={followTab}
                    setShowFollowers={setShowFollowers}
                  />
                ) : (
                  <>
                    {activeTab === 0 && (
                      <div className="tab_1_style">
                        <ProfileDetailsForm
                          onEdit={() => setShowModal(true)}
                          setShowModal={setShowModal}
                        />
                      </div>
                    )}

                    {activeTab === 1 && <MyReviews userId={user?._id} />}
                    {activeTab === 2 && (
                      <MyFavouritesTab
                        setShowModal1={setShowModal1}
                        refreshFavList={refreshFavList}
                      />
                    )}
                    {activeTab === 3 && <NotificationsTab />}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ChangePasswordModal show={showModal} onClose={handleCloseModal} />
      <CreateListModal
        show={showModal1}
        onClose={handleCloseModal1}
        onListCreated={() => setRefreshFavList((prev) => !prev)}
      />

      <CommonModal
        title={"Logout?"}
        para={"Are you sure, You want to logout?"}
        body={
          <div className="btn_Flex">
            <Button
              onClick={handleCloseModal2}
              variant="outline-info"
              className="border-radius-100"
            >
              Cancel
            </Button>
            <Button
              onClick={handleLogout}
              variant="info"
              className="border-radius-100"
            >
              Yes I'm Sure
            </Button>
          </div>
        }
        show={showModal2}
        onClose={handleCloseModal2}
      />
    </React.Fragment>
  );
};

export default MyProfile;
